import React from 'react'
import './styles.scss'

function ArrowButton({ className = '', ...props }) {
  return <button type="button" className={`arrow ${className}`} {...props}></button>
}

export default ArrowButton
